import { createHookStore, STORE_NAMES } from '@namespace/helpers-store';

// bs is abbreviation of bonus system
export const initialState = {
  crmWagerBonuses: [],
  bsWagerBonus: {},
  bsDepositBonuses: [],
  bsWithdrawBonuses: [],
  bonusDetails: {},
  bonusTemplatesImages: {},
  isBonusTemplatesImagesLoaded: false,
  isUpdateFreeSpinBonusList: false,
  isUpdateFundsBonusList: false,
  jackpotsWinsBonuses: [],
  allTypesBonuses: {
    data: {},
    ids: [],
    isNextPageExist: false
  },
  allTypesBonusesHistory: {
    data: {},
    ids: [],
    isNextPageExist: false
  },
  crmFundsBonuses: {
    data: {},
    ids: [],
    totalCount: 0
  },
  crmFundsBonusesHistory: {
    data: {},
    ids: [],
    totalCount: 0
  },
  bsFundsBonuses: {
    data: {},
    ids: [],
    totalCount: 0
  },
  bsFundsBonusesHistory: {
    data: {},
    ids: [],
    totalCount: 0
  },
  freeSpinBonuses: {
    data: {},
    ids: [],
    totalCount: 0
  },
  freeSpinBonusesHistory: {
    data: {},
    ids: [],
    totalCount: 0
  },
  riskFreeBonuses: {
    data: {},
    ids: [],
    totalCount: 0
  },
  riskFreeBonusesHistory: {
    data: {},
    ids: [],
    totalCount: 0
  }
};

export const useBonusesStore = createHookStore(
  STORE_NAMES.BONUSES,
  initialState
);
